import { render, staticRenderFns } from "./AAQuickLook.vue?vue&type=template&id=652f684c&"
import script from "./AAQuickLook.vue?vue&type=script&lang=js&"
export * from "./AAQuickLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('652f684c')) {
      api.createRecord('652f684c', component.options)
    } else {
      api.reload('652f684c', component.options)
    }
    module.hot.accept("./AAQuickLook.vue?vue&type=template&id=652f684c&", function () {
      api.rerender('652f684c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/AAQuickLook.vue"
export default component.exports